<template>
	<img :src="url" class="file-preview-image" alt="" />
</template>

<script lang="ts" setup>
defineProps<{ url: string }>();
</script>

<style lang="scss">
.file-preview-image {
	max-width: 100%;
	max-height: 100%;
	margin: 0 auto;
	object-fit: contain;
}
</style>
